import React from "react";
import { NavLink } from "react-router-dom";
import { IListObj } from "../../types/genericTypes";
import "../../../assets/scss/components/generic/SecNavigation/SecNavigationDesktop.scss";

export interface ISecNavigationDesktopProps {
	defaultValue?: number | string; // default selected value
	list: Array<IListObj>; // list of all options in dropdown
	onSelect?: (id: string | number) => void; // the function to be called onSelect
}

// This component will adjust according to the space of its parent
const SecNavigationDesktop: React.FC<ISecNavigationDesktopProps> = (props: ISecNavigationDesktopProps) => {
	return (
		<ul className="sec_navigation_desktop">
			{props.list.map((item) => (
				<li
					className={"navigation_item" + (item.value === props.defaultValue ? " active" : "")}
					key={item.value}
					// onClick={() => itemSelected(item.value)}
				>
					{item.href && (
						<NavLink activeClassName="selected" to={item.href}>
							{item.display}
						</NavLink>
					)}
					{!item.href && item.display}
				</li>
			))}
		</ul>
	);
};

export default SecNavigationDesktop;
